<!-- Header -->
<div class="header">
  <div class="container">
    <!-- Logo -->
    <div class="header-logo">
      <h3 class="font-family-syne letter-spacing-1"><a routerLink="/">Komo</a></h3>
    </div>
    <!-- Fullscreen Menu Toggle -->
    <button class="fm-toggle" (click)="toggleMenu()">
      <span class="lines"></span>
    </button>
  </div><!-- end container -->
</div>

<!-- Fullscreen Menu -->
<div class="fullscreen-menu bg-black" [ngClass]="{'fm-show': isMenuOpen}">
  <div class="fm-wrapper">
    <div class="position-middle">
      <div class="container">
        <div class="row g-4">
          <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div class="row g-4 align-items-center">
              <div class="col-12 col-md-6">
                <ul class="list-unstyled">
                  <li>
                    <h6 class="fw-semi-bold uppercase letter-spacing-2"><a class="text-link-2" routerLink="/">Home</a></h6>
                  </li>
                  <li>
                    <h6 class="fw-semi-bold uppercase letter-spacing-2"><a class="text-link-2" routerLink="/about-us">About</a></h6>
                  </li>
                  <li>
                    <h6 class="fw-semi-bold uppercase letter-spacing-2"><a class="text-link-2" routerLink="/portfolio-two-column">Portfolio</a></h6>
                  </li>
                  <li>
                    <h6 class="fw-semi-bold uppercase letter-spacing-2"><a class="text-link-2" routerLink="/blog-grid">Blog</a></h6>
                  </li>
                  <li>
                    <h6 class="fw-semi-bold uppercase letter-spacing-2"><a class="text-link-2" routerLink="/contact">Contact</a></h6>
                  </li>
                </ul>
              </div>
              <div class="col-12 col-md-6">
                <h5 class="fw-semi-bold">Contact Info:</h5>
                <ul class="list-unstyled">
                  <li>Patton Street Caulfield East VIC 3145</li>
                  <li>yoursite&#64;example.com</li>
                </ul>
                <ul class="list-inline-sm mt-4">
                  <li><a class="button-circle button-circle-sm button-circle-white-2" href="#"><i class="bi bi-facebook"></i></a></li>
                  <li><a class="button-circle button-circle-sm button-circle-white-2" href="#"><i class="bi bi-twitter-x"></i></a></li>
                  <li><a class="button-circle button-circle-sm button-circle-white-2" href="#"><i class="bi bi-instagram"></i></a></li>
                </ul>
              </div>
            </div><!-- end row(inner) -->
          </div>
        </div><!-- end row(outer) -->
      </div><!-- end container -->
    </div><!-- end position-middle -->
    <!-- Close button -->
    <button class="fm-close" (click)="closeMenu()">
      <span></span>
    </button>
  </div><!-- end fm-wrapper -->
</div><!-- end fullscreen-menu -->
<!-- end Header -->

<!-- Hero section -->
<div class="px-4 px-lg-5">
    <div class="section-xl position-relative bg-dark-05 border-radius-1">
        <!-- Background Video -->
        <div class="bg-video">
            <video playsinline autoplay muted loop>
                <source src="assets/videos/home-video-1.mp4" type="video/mp4">
            </video>
        </div>
        <!-- end Background Video -->
        <div class="container text-center">
            <div class="row">
                <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                    <h1 class="display-1 font-family-syne fw-semi-bold mb-0 text-white">Seamless IT Solutions for a Smarter Future
                    </h1>
                </div>
            </div><!-- end row -->
        </div><!-- end container -->
    </div>
</div>
<!-- end Hero section -->

<!-- Portfolio section -->
<div class="section">
  <div class="container">
    <div class="mb-5">
        <div class="row text-center">
            <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                <h2 class="display-4 fw-bold font-family-syne letter-spacing-2 m-0">Latest Works</h2>
            </div>
        </div>
    </div>
    <div class="row g-4 portfolio-grid hover-style-3 border-radius">
      <div class="col-12 col-md-6 portfolio-item" *ngFor="let work of portfolioWorks">
      <div class="portfolio-box">
        <div class="portfolio-img">
        <img [src]="work.img" [alt]="work.title">
        </div>
        <a [routerLink]="work.link"></a>
        <div class="portfolio-title">
        <div class="portfolio-title-item">
          <h5 class="font-family-syne fw-normal">{{ work.title }}</h5>
        </div>
        <div class="portfolio-title-item">
          <span>{{ work.category }}</span>
        </div>
        </div>
      </div>
      </div>
    </div><!-- end portfolio-grid -->
  </div><!-- end container -->
</div>
<!-- end Portfolio section -->

<!-- Facts section -->
<div class="px-4 px-lg-5">
    <div class="section-lg bg-gray-lighter border-radius">
        <div class="container text-center">
            <div class="row g-4">
                <div *ngFor="let fact of funFacts" class="col-12 col-sm-6 col-md-3">
                    <h1 class="fw-semi-bold font-family-syne"><span class="counter">{{fact.displayedNumber | number:'1.0-0'}}</span></h1>
                    <h6 class="font-large fw-medium font-family-syne mt-2">{{fact.title}}</h6>
                    <p>{{fact.desc}}</p>
                </div>
            </div><!-- end row -->
        </div><!-- end container -->
    </div><!-- end section-lg -->
</div>
<!-- end Facts section -->

<!-- Team section -->
<div class="section">
    <div class="container">
        <div class="mb-5">
            <div class="row text-center">
                <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                    <h2 class="display-4 fw-bold font-family-syne letter-spacing-2 m-0">Our Creative Team</h2>
                </div>
            </div>
        </div>
        <div class="row gx-3 gy-4">
            <div class="col-12 col-sm-6 col-lg-3 team-style-01 text-center" *ngFor="let member of teamMembers">
                <figure class="border-radius">
                    <div class="team-member-image">
                        <img [src]="member.image" [alt]="member.name">
                        <div class="team-overlay bg-overlay border-radius"></div>
                    </div>
        
                    <figcaption
                        class="align-items-center justify-content-center d-flex flex-column pd-l-20 pd-r-20 pd-t-30 pd-b-30">
                        <span class="team-title d-block alt-font text-light font-family-syne">
                            {{ member.name }}
                        </span>
        
                        <span class="team-sub-title d-block text-light font-family-syne">
                            {{ member.position }}
                        </span>
        
                        <div class="social-icon position-bottom">
                            <a *ngFor="let social of member.socials" [href]="social.link" class="text-light" target="_blank">
                                <i [class]="social.icon"></i>
                            </a>
                        </div>
                    </figcaption>
                </figure>
            </div>
        </div>
        <!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Team section -->

<!-- section -->
<div class="px-4 px-lg-5">
    <div class="section-xl position-relative bg-dark-02 border-radius">
        <div class="bg-video">
            <video playsinline autoplay muted loop>
                <source src="assets/videos/bg-video.mp4" type="video/mp4">
            </video>
        </div>
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-lg-8 col-xl-7">
                    <h1 class="display-3 font-family-syne fw-semi-bold">Unlock the Power of Technology</h1>
                    <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
                </div>
                <div class="col-12 col-lg-4 col-xl-5 text-lg-end">
                    <a class="button button-xl button-rounded button-reveal-right-outline-white" routerLink="/contact"><i class="bi bi-arrow-right"></i><span>Get In Touch</span></a>
                </div>
            </div><!-- end row -->
        </div><!-- end container -->
    </div>
</div>
<!-- end section -->

<!-- Services section -->
<div class="section-lg">
    <div class="container text-center">
        <div class="mb-5">
            <div class="row text-center">
                <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                    <h2 class="display-4 fw-bold font-family-syne letter-spacing-2 m-0">Our Services</h2>
                </div>
            </div>
        </div>
        <div class="row g-4 icon-5xl">
            <div class="col-12 col-md-4" *ngFor="let service of services">
                <div class="mb-2">
                    <i [class]="service.icon + ' text-dark'"></i>
                </div>
                <h5 class="fw-normal font-family-syne">
                    {{ service.title }}
                </h5>
                <p>
                    {{ service.description }}
                </p>
            </div>
        </div>
        <!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Services section -->

<!-- Clients section -->
<div class="section bg-gray-lighter">
    <div class="container">
        <owl-carousel-o [options]="brandCarouselOptions" class="client-carousel">
            <ng-template carouselSlide *ngFor="let brand of brands">
                <div class="client-box">
                <a routerLink="/">
                    <img [src]="brand.image" [alt]="brand.alt">
                </a>
                </div>
            </ng-template>
        </owl-carousel-o><!-- end owl-carousel -->
    </div><!-- end container -->
</div>
<!-- end Clients section -->

<!-- Blog section -->
<div class="section">
    <div class="container">
        <div class="mb-5">
            <div class="row text-center">
                <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                    <h2 class="display-4 fw-bold font-family-syne letter-spacing-2 m-0">Our Latest Blogs</h2>
                </div>
            </div>
        </div>
        <owl-carousel-o [options]="customOptions">
            <ng-container *ngFor="let blog of blogItems">
                <ng-template carouselSlide>
                    <div>
                    <div class="hoverbox-6 border-radius">
                        <a [routerLink]="blog.link">
                        <img [src]="blog.image" [alt]="blog.alt">
                        <div class="content top bg-dark border-radius">
                            <span class="font-family-poppins font-small fw-normal uppercase m-0 text-white">
                            {{ blog.category }}
                            </span>
                        </div>
                        </a>
                    </div>
                    <div class="p-3">
                        <h5 class="fw-normal m-0">
                        <a class="text-link-1" [routerLink]="blog.link">{{ blog.title }}</a>
                        </h5>
                        <span>{{ blog.date }}</span>
                    </div>
                    </div>
                </ng-template>
            </ng-container>
        </owl-carousel-o><!-- end owl-carousel -->
    </div><!-- end container -->
</div>
<!-- end Blog section -->

<app-footer></app-footer>
